{
  "name": "dictionary-service-frontend",
  "version": "20.1.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ncp src/assets/config/config-local.json src/assets/config/config.json && ng serve",
    "start:localWithTestingBe": "ncp src/assets/config/config-testing.json src/assets/config/config.json && ng serve",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "test": "jest --ci --silent --maxWorkers=50%",
    "test:ci": "node --expose-gc ./node_modules/.bin/jest --ci --silent --maxWorkers=20%",
    "test:coverage": "jest --coverage",
    "lint": "ng lint",
    "format:fix": "pretty-quick --staged",
    "commit": "git add . && npx git-cz",
    "update:icons": "npx copy-lib-icons icons.config.js",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@akelius-edu/edu-user": "^0.1.2",
    "@akelius-edu/platforms-ui": "1.2.15",
    "@akelius-edu/shared-components": "1.3.20",
    "@akelius-edu/shared-core": "1.1.1",
    "@angular/animations": "^20.3.26",
    "@angular/cdk": "20.2.14",
    "@angular/cdk-experimental": "20.2.14",
    "@angular/common": "^20.3.26",
    "@angular/compiler": "^20.3.26",
    "@angular/core": "^20.3.26",
    "@angular/forms": "^20.3.26",
    "@angular/material": "20.2.14",
    "@angular/platform-browser": "^20.3.26",
    "@angular/platform-browser-dynamic": "^20.3.26",
    "@angular/router": "^20.3.26",
    "@auth0/auth0-spa-js": "^1.9.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^3.0.1",
    "@ngxs/devtools-plugin": "^19.0.0",
    "@ngxs/form-plugin": "^19.0.0",
    "@ngxs/logger-plugin": "^19.0.0",
    "@ngxs/storage-plugin": "^19.0.0",
    "@ngxs/store": "^19.0.0",
    "@sentry/angular": "^9.28.1",
    "file-saver": "^2.0.5",
    "jwt-decode": "^3.1.2",
    "ngx-scanner-qrcode": "1.7.6",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^19.0.1",
    "@angular-eslint/builder": "19.8.0",
    "@angular-eslint/eslint-plugin": "19.8.0",
    "@angular-eslint/eslint-plugin-template": "19.8.0",
    "@angular-eslint/schematics": "19.8.0",
    "@angular-eslint/template-parser": "19.8.0",
    "@angular/build": "^20.3.32",
    "@angular/cli": "^20.3.32",
    "@angular/compiler-cli": "^20.3.26",
    "@angular/language-service": "^20.3.26",
    "@types/jest": "29.5.14",
    "@types/node": "^24.19.1",
    "@typescript-eslint/eslint-plugin": "8.34.0",
    "@typescript-eslint/parser": "8.34.0",
    "eslint": "^9.28.0",
    "husky": "^9.1.7",
    "jest": "29.7.0",
    "jest-preset-angular": "14.6.0",
    "ncp": "2.0.0",
    "prettier": "^3.5.3",
    "pretty-quick": "^4.2.2",
    "ts-jest": "^29.4.0",
    "ts-node": "^10.9.2",
    "typescript": "~5.8.3"
  }
}
